import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, selectCartData } from "../../ReduxSlice/BookSlice";
import PdfModal from "../../common/PdfModal";
import config from "../../config/config";
import BuyNowButton from "../posCommon/BuyNowButton";

const BooksContent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const cartItems = useSelector(selectCartData);

  const [bookDetails, setBookDetails] = useState(null);
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchBook = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/Home/Getbooks`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        });
        const data = await res.json();
        setBookDetails(data?.[0]);
      } catch (err) {
        console.error(err);
      }
    };
    fetchBook();
  }, [API_BASE_URL, id]);

  if (!bookDetails) {
    return <div className="p-4 text-center">Loading book...</div>;
  }

  /* ------------------ ACTIONS ------------------ */
  const handleAddToCart = () => {
  const alreadyInCart = cartItems.some(
    (item) => item.id === bookDetails.id
  );

  // ✅ If already in cart → go to cart
  if (alreadyInCart) {
    navigate("/pos/cart");
    return;
  }

  // Free book case
  if (bookDetails.price === "" || bookDetails.price === "-") {
    window.open(bookDetails.pdflink, "_blank");
    return;
  }

  const bookToAdd = {
    ...bookDetails,
    price: bookDetails.discountedprice || bookDetails.price,
    quantity: 1,
  };

  dispatch(addToCart(bookToAdd));
  navigate("/pos/cart");
};


  const handleView = () => {
    if (bookDetails.pdflink.includes("drive.google.com")) {
      window.open(bookDetails.pdflink, "_blank");
    } else {
      setPdfUrl(bookDetails.pdflink);
      setShowPdf(true);
    }
  };

  /* ------------------ UI ------------------ */
  return (
  <div className="w-full max-w-7xl mx-auto px-4 pb-28 lg:pb-10">
    {/* MAIN LAYOUT */}
    <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-10">
      
      {/* LEFT — IMAGE */}
      <div className="flex justify-center lg:justify-start">
        <img
          src={bookDetails.image}
          alt={bookDetails.booknameinenglish}
          className="w-full max-w-md lg:max-w-lg h-auto object-contain rounded-xl bg-gray-100 shadow"
        />
      </div>

      {/* RIGHT — DETAILS */}
      <div className="flex flex-col">
        <h1 className="text-3xl font-bold text-orange-500">
          {bookDetails.booknameinenglish}
        </h1>
        <p className="text-gray-600 mt-1 text-lg">
          Writer: {bookDetails.writer}
        </p>

        {/* PRICE */}
        <div className="mt-6 flex items-end gap-4">
          {bookDetails.price && (
            <span className="line-through text-gray-400 text-xl">
              ₹{bookDetails.price}
            </span>
          )}
          <span className="text-3xl font-bold text-gray-900">
            ₹{bookDetails.discountedprice || bookDetails.price}
          </span>
        </div>

        {/* DESCRIPTION */}
        <div className="mt-6 bg-gray-100 rounded-xl p-5 leading-relaxed">
          <p className="font-semibold mb-2 text-lg">
            {bookDetails.booknameinhindi}
          </p>
          <p>{bookDetails.description}</p>

          <div className="mt-4 space-y-1 text-gray-700">
            {bookDetails.agegroup && <p>Age Group: {bookDetails.agegroup}</p>}
            {bookDetails.noofpages && <p>Pages: {bookDetails.noofpages}</p>}
          </div>
        </div>

        {/* DESKTOP ACTION BUTTONS */}
        <div className="hidden lg:flex gap-3 mt-8">
          <button
  onClick={handleAddToCart}
  className={`flex-1 py-3 rounded-lg font-semibold text-white ${
    cartItems.some((item) => item.id === bookDetails.id)
      ? "bg-green-600 hover:bg-green-700"
      : "bg-indigo-600 hover:bg-indigo-700"
  }`}
>
  {cartItems.some((item) => item.id === bookDetails.id)
    ? "Go to Cart"
    : "Add to Cart"}
</button>


          <BuyNowButton
            book={{
              ...bookDetails,
              price: bookDetails.discountedprice || bookDetails.price,
            }}
          />
        </div>
      </div>
    </div>

    {/* MOBILE STICKY BAR (unchanged) */}
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t p-3 flex gap-2 z-50">
      <button
  onClick={handleAddToCart}
  className={`flex-1 py-3 rounded-lg font-semibold text-white ${
    cartItems.some((item) => item.id === bookDetails.id)
      ? "bg-green-600 hover:bg-green-700"
      : "bg-indigo-600 hover:bg-indigo-700"
  }`}
>
  {cartItems.some((item) => item.id === bookDetails.id)
    ? "Go to Cart"
    : "Add to Cart"}
</button>


      <BuyNowButton
        book={{
          ...bookDetails,
          price: bookDetails.discountedprice || bookDetails.price,
        }}
      />
    </div>

    {/* PDF MODAL */}
    {showPdf && (
      <PdfModal
        value={showPdf}
        pdf_link={pdfUrl}
        onClose={() => setShowPdf(false)}
      />
    )}
  </div>
);

};

export default BooksContent;
